import React from 'react';

import cn from 'classnames';
import { useTranslation } from 'react-i18next';

import { formatPrice, getPluralized } from '@shared/helpers';

import cls from './TooltipWarehouseColumnInfo.module.css';

import type { WarehouseTotalInfo } from '@entities/equipment';

interface WarehouseColumnInfoProps {
    classes?: string;
    totalInfo: WarehouseTotalInfo;
}

export const TooltipWarehouseColumnInfo = ({
    classes,
    totalInfo,
}: WarehouseColumnInfoProps) => {
    const { t } = useTranslation();

    const getPositionText = (count: number) =>
        getPluralized(count, {
            one: t('BoardHeader.return.position'),
            few: t('BoardHeader.return.position_genitive'),
            many: t('BoardHeader.return.positions'),
        });

    return (
        <div className={cn(cls.TooltipWarehouseColumnInfo, classes)}>
            <div>
                {getPositionText(totalInfo.inventoryCount)} {t('BoardHeader.return.for_the_amount')}{' '}
                {formatPrice(totalInfo.totalInventoryCost, {
                    maximumFractionDigits: 2,
                    currencySign: totalInfo.currency.sign,
                })}
            </div>
            <div className={cls.separator} />
            <div>
                {t('BoardHeader.return.written_off')}{' '}
                {getPositionText(totalInfo.decommissionedInventoryCount)}{' '}
                {t('BoardHeader.return.for_the_amount')}{' '}
                {formatPrice(totalInfo.decommissionedInventoryCost, {
                    maximumFractionDigits: 2,
                    currencySign: totalInfo.currency.sign,
                })}
            </div>
        </div>
    );
};
